import React, { Component } from "react";
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class EmailNotifications extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		emailsArray: []
    }
	
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	this.getPreferences();
}

getPreferences=()=>{
	var emailArrayVar = [];
	var postData = { userId: JSON.parse(localStorage.getItem('userData')).id, type: 2 }
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/getUserPreferences", postData).then(res => {
		var preferencesArray = res.data.responseData.userPreferences;
		
		for ( var i = 0; i < preferencesArray['Confirmations Emails'].length; i++ )
			{
				var objectConfirmation = preferencesArray['Confirmations Emails'][i];
				
				if ( objectConfirmation.emailName == 'Signed Up for Class' ) { objectConfirmation.emailName = 'Class Signup'; }
				if ( objectConfirmation.emailName == 'Cancelled Class' ) { objectConfirmation.emailName = 'Class Cancellation'; }
				if ( objectConfirmation.emailName == 'Invites to Class' ) { objectConfirmation.emailName = 'Class Invite'; }
			
				let confirmPush = {
					id: objectConfirmation.id,
					name: objectConfirmation.emailName,
					status: objectConfirmation.status
				};
				
				emailArrayVar.push(confirmPush);
			}
			
		for ( var y = 0; y < preferencesArray['Reminders Emails'].length; y++ )
			{
				var objectRemined = preferencesArray['Reminders Emails'][y];
				
				if ( objectRemined.emailName == '15 - minute reminder' ) { objectRemined.emailName = 'Class Reminder'; }
				
				let confirmPush = {
					id: objectRemined.id,
					name: objectRemined.emailName,
					status: objectRemined.status
				};
				
				emailArrayVar.push(confirmPush);
			}
		
		this.setState({emailsArray: emailArrayVar});
	}).catch(err =>{ });
}

updateStatus=(i)=>{
	var emailArrayVar = this.state.emailsArray;
	emailArrayVar[i].status = !emailArrayVar[i].status;
	this.setState({emailsArray: emailArrayVar}, () => this.updateEmailsSettings());
}

updateEmailsSettings=()=>{
	var postData = { emailsStatus: JSON.stringify(this.state.emailsArray) };
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/updateEmailPreferences", postData).then(res => { }).catch(err =>{ });	
}

  render() {
	 return (
		<div className="options_settins_content">
			{ this.state.emailsArray.map((item, i) =>
				<div className="one_toggle_option" key={i}>
					<div className="title_toggle_option">{item.name}
						<div className="switch_check" onClick={() => this.updateStatus(i)}>
							<input type="checkbox" checked={item.status} />
							<span className="slider_filter round_filter"></span>
						</div>
					</div>
				</div>
			)}
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  }
)(EmailNotifications);
